import { HttpClient, HttpResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { first, merge, Observable, of, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HTTP_ENDPOINTS } from '../external/http';
import { PostReleaseDto, ReleaseDto, ReleaseIsVisibleDto } from '../models/release/release-dto';

@Injectable({
  providedIn: 'root',
})
export class ForgeService {

  private releases: ReleaseDto[] = [];
  private releases$: EventEmitter<ReleaseDto[]> = new EventEmitter();
  private fetchReleasesSubscription?: Subscription;

  constructor(private http: HttpClient) { }

  public refreshReleases(): void {
    this.fetchReleasesSubscription?.unsubscribe();
    this.fetchReleasesSubscription = this.fetchReleases().subscribe(releases => {
      this.releases = releases;
      this.releases$.emit(releases);
    });
  }

  public getReleases$(): Observable<ReleaseDto[]> {
    if (this.releases.length > 0) return merge(of(this.releases), this.releases$);

    return this.releases$;
  }

  private fetchReleases(): Observable<ReleaseDto[]> {
    return this.http.get<ReleaseDto[]>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.FORGE_PATH}`)
      .pipe(first());
  }

  public fetchReleaseZipFile(releaseName: string, repositoryName: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${environment.apiBasePath}/${HTTP_ENDPOINTS.FORGE_PATH}/${releaseName}/${repositoryName}`,
      { responseType: 'blob', observe: 'response' });
  }

  public createRelease(createReleaseDto: PostReleaseDto): Observable<ReleaseDto> {
    return this.http.post<ReleaseDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.FORGE_PATH}`, createReleaseDto)
      .pipe(first());
  }

  public updateReleaseIsVisible(releaseIsVisibleDto: ReleaseIsVisibleDto, releaseId: string): Observable<ReleaseDto> {
    return this.http.put<ReleaseDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.FORGE_PATH}/visible/${releaseId}`, releaseIsVisibleDto)
      .pipe(first());
  }

  public deleteRelease(releaseId: string): Observable<ReleaseDto> {
    return this.http.delete<ReleaseDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.FORGE_PATH}/${releaseId}`)
      .pipe(first());
  }

}
